var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", staticClass: "container-cadastro" },
    [
      _c("div", { staticClass: "card-header" }, [
        _vm._v("Retificação de cadastro de arrecadação")
      ]),
      _c(
        "el-tabs",
        {
          staticClass: "content",
          attrs: { id: "scroll", value: _vm.menu },
          on: { "tab-click": _vm.mudarTab }
        },
        [
          _vm._l(_vm.tabs, function(tab) {
            return [
              _c("el-tab-pane", { attrs: { name: tab.name } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _vm._v(_vm._s(tab.label) + "  "),
                    _vm.tabPossuiErro(tab.label)
                      ? _c(
                          "el-tooltip",
                          { attrs: { effect: "light", placement: "bottom" } },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "content" }, slot: "content" },
                              _vm._l(_vm.getErrosTab(tab.label), function(
                                erro
                              ) {
                                return _c("p", [
                                  _c("pre", [_vm._v(_vm._s(erro))])
                                ])
                              }),
                              0
                            ),
                            _c("i", {
                              staticClass: "el-icon-warning tooltip-icon"
                            })
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          }),
          _vm.historicoDespachos && _vm.historicoDespachos.length
            ? _c("despachos", {
                attrs: {
                  cadastroColetivo: _vm.cadastroColetivo,
                  despachos: _vm.historicoDespachos,
                  isRetificacao: true
                }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "container-tab" },
            [
              _c(
                "validation-observer",
                { ref: "observer", attrs: { tag: "form" } },
                [
                  _c(
                    "keep-alive",
                    [
                      _vm.cadastroColetivo.id
                        ? _c("router-view", {
                            attrs: { cadastroColetivo: _vm.cadastroColetivo },
                            on: {
                              onRemoveGeometria: _vm.onRemoveGeometria,
                              atualizarGeorreferenciamento:
                                _vm.atualizarPecaTecnica
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm.isUltimoPasso && _vm.radiosAcoes.length
        ? _c("app-radios-tramitacao", {
            attrs: {
              radios: _vm.radiosAcoes,
              isDecisao: true,
              radioInicial: _vm.radioInicial
            },
            on: { changeRadio: _vm.changeRadio }
          })
        : _vm._e(),
      _c("app-buttons-cadastro", {
        attrs: {
          isPrimeiroPasso: _vm.isPrimeiroPasso,
          isUltimoPasso: _vm.isUltimoPasso,
          showButtonSalvar: true,
          showButtonProximo: !_vm.isUltimoPasso
        },
        on: {
          proximo: _vm.proximo,
          salvar: _vm.salvarCadastro,
          voltar: _vm.voltar,
          cancelar: _vm.cancelar,
          finalizar: _vm.finalizarCadastro
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d18238d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d18238d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/gat/components/retificacaoCadastro/RetificacaoCadastro.vue
// module id = null
// module chunks = 